import { Location } from 'models/locations';
import Seller from 'models/seller';

export const GOT_SELECTED_LOCATION = 'got-selected-location';

export default function gotSelectedLocation({ body, nonBookableRules }) {
  Object.assign(body, { seller_id: body._embedded['pw:seller'].id });
  const location = new Location({ _embedded: { 'pw:location': body } }, { nonBookableRules });
  const sellerResponse = body._embedded['pw:seller'];
  const seller = new Seller(sellerResponse);

  return {
    type: GOT_SELECTED_LOCATION,
    payload: {
      location,
      seller,
    },
  };
}
